export default __webpack_public_path__ + "static/media/soon.afa7a402.svg";